import React from 'react';
import {MasterCard} from "./masterCard"
function Master() {
  return (
    <div >
      <MasterCard />
    </div>
  );
}

export default Master;